module.exports = __webpack_public_path__ + "health3.G1y_ULs3.svg";